import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Option, Response, StaticMethods} from '../../model/GeneralModels';
import {ListService} from '../../services/list.service';

@Component({
  selector: 'app-state-and-city-field',
  template: `
    <div class="form-group">
      <div class="row col-12" style="margin-right: 1px !important;">
        <div class="col-6" style="margin-left: 5px !important;">
          <app-select-field [Group]="form" [fieldName]="stateFieldName" [fieldLabel]="'استان'"
                            [options]="states$" (OnChange)="onStateChange($event)"></app-select-field>
        </div>
        <div class="col-6" style="margin-left: 5px;">
          <app-select-field [Group]="form" [fieldName]="cityFieldName" [fieldLabel]="'شهر'" [options]="cities$"
                            (OnChange)="setCityName($event)"
          ></app-select-field>
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    '../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css',
  ],
})
export class StateAndCityFieldComponent implements OnInit, OnChanges {
  cities$: Option[] = [];
  states$: Option[] = [];
  @Input() form: FormGroup;
  @Input() cityFieldName: string;
  @Input() required: boolean;
  @Input() stateFieldName: string;
  @Input() viewList: any = {};
  @Input() productName: string;

  constructor(private stateListService: ListService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.form) {
      if (!this.form.controls[this.cityFieldName]) {
        this.form.controls[this.cityFieldName] = new FormControl('');
        if (this.required) {
          this.form.controls[this.cityFieldName].setValidators(Validators.required);
        }
      }
      if (!this.form.controls[this.stateFieldName]) {
        this.form.controls[this.stateFieldName] = new FormControl('');
        if (this.required) {
          this.form.controls[this.stateFieldName].setValidators(Validators.required);
        }
      }
      this.stateListService.getStateList(this.productName).subscribe(response => {
        this.states$ = [];
        for (let i = 0; i < response.data.states.length; i++) {
          this.states$[i] = new Option(response.data.states[i].persianName, response.data.states[i].stateCode);
        }
      });
    }
  }



  onStateChange(selectedStateID) {
    this.cities$ = [];
    const selectedState = this.states$.find(state => {
      return state.value === StaticMethods.dynamicParse(selectedStateID, typeof state.value);
    });
    this.viewList.stateName = selectedState.label;
    this.stateListService.getCityList(this.productName, parseInt(selectedStateID, 10)).subscribe((response: Response) => {
      if (!response.data.cities.length) {
        this.cities$[0] = new Option('', 'هشتگ بیمه استان انتخاب شده را پوشش نمی دهد');
      } else {
        this.cities$ = response.data.cities;
        for (let i = 0; i < response.data.cities.length; i++) {
          this.cities$[i] = new Option(response.data.cities[i].persianName, response.data.cities[i].cityCode);
        }
      }
      this.form.controls[this.cityFieldName].patchValue('');
    });
  }

  setCityName(selectedCityID) {
    const selectedCity = this.cities$.find(city => {
      return city.value === StaticMethods.dynamicParse(selectedCityID, typeof city.value);
    });
    this.viewList.cityName = selectedCity.label;
  }
}
